//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getProvinceList, getCityList, getAreaList, getIdByName, activeApply, getUserInfo, getSmsCode } from '@/request/api'
export default {
    name: 'yashiApply',
    data () {
        return {
            name: '',
            phone: '',
            code: '',
            inputAddress: '',
            codeMessage: '获取验证码',
            time: 60,
            isCountDown: false,
            address: '请选择地址',
            service: '请选择服务',
            serviceId: '',
            checked: false,
            showAddress: false,
            areaColumns: [
                // 第一列
                // 第二列
                // {
                //     values: ['上午', '下午', '晚上'],
                //     defaultIndex: 1,
                // },
            ],
            serviceShow: false,
            serviceColumn: [
                { text: '墙面涂刷', value: 1 },
                { text: '木器涂刷', value: 2 },
                { text: '阳台涂刷', value: 3 },
                { text: '瓷砖美缝', value: 4 },
                { text: '防水施工', value: 5 },
                { text: '外墙涂刷', value: 6 }
            ],
            provinceId: '',
            cityId: '',
            areaId: '',
            scene: ''
        }
    },
    mounted () {
        document.title = '亚士美家服务'
        
        const self = this
        const scene = this.getSearchString('scene', window.location.href) || ''
        const token = this.getSearchString('token', window.location.href) || ''
        
        this.scene = scene

        sessionStorage.setItem('token', token)

        if (token) this.getUserInfo()

        AMap.plugin('AMap.Geolocation', function() {
            var geolocation = new AMap.Geolocation({
                enableHighAccuracy: true, //是否使用高精度定位，默认:true
                timeout: 1000, //超过10秒后停止定位，默认：5s
                buttonPosition: 'RB', //定位按钮的停靠位置
                buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
            });

            geolocation.getCurrentPosition(function(status, result) {
                if (status === 'complete') {
                    const lng = result.position.lng
                    const lat = result.position.lat

                    AMap.plugin('AMap.Geocoder', function () {
                        var geocoder = new AMap.Geocoder({
                            // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                            // city: '010'
                        })

                        geocoder.getAddress([lng, lat], function(status, res) {
                            if (status === 'complete' && res.info === 'OK') {
                                // result为对应的地理位置详细信息
                                const { addressComponent } = res.regeocode
                                const areaName = `${addressComponent.province} ${addressComponent.city || addressComponent.province} ${addressComponent.district}`
                                
                                self.address = areaName || ''

                                self.test1 = areaName

                                self.getIdByName(areaName)
                            } else {
                               self.getIdByName() 
                            }
                        })
                    })
                } else {
                    self.getIdByName()
                }
            });
        });
    },
    methods: {
        getUserInfo: function () {
            getUserInfo({}).then(res => {
                if (res.code === 1) {
                    this.info = JSON.stringify(res.data)
                    this.phone = res.data.user.mobile
                }
            })
        },
        getIdByName: function (areaName) {
            const params = { region: areaName }

            getIdByName(params).then(res => {
                if (res.code === 200) {
                    const provinceId = res.data[0].id
                    const cityId = res.data[1].id
                    const areaId = res.data[2].id

                    this.provinceId = provinceId
                    this.cityId = cityId
                    this.areaId = areaId

                    this.getProvinceList(provinceId, cityId, areaId)
                } else {
                    this.getProvinceList()
                }
            })
        },
        getProvinceList: function (provinceId, cityId, areaId) {
            const params = { type: 1 }

            getProvinceList(params).then(res => {
                if (res.code === 1) {
                    let arr = []

                    res.data.forEach(element => {
                      const obj = {
                        text: element.name,
                        value: element.id
                      }

                      arr.push(obj)
                    })

                    const cell = {
                        values: arr,
                        defaultIndex: arr.findIndex(item => item.value == provinceId) || 0
                    }

                    this.$set(this.areaColumns, 0, cell)

                    this.getCityList(provinceId || res.data[0].id, cityId, areaId)
                }
            })
        },
        getCityList: function (provinceId, cityId, areaId) {
            const params = {
                type: 2,
                id: provinceId
            }

            getCityList(params).then(res => {
                if (res.code === 1) {
                    let arr = []

                    res.data.forEach(element => {
                      const obj = {
                        text: element.name,
                        value: element.id
                      }

                      arr.push(obj)
                    })

                    const cell = {
                        values: arr,
                        defaultIndex: arr.findIndex(item => item.value == cityId) || 0
                    }

                    this.$set(this.areaColumns, 1, cell)

                    this.getAreaList(cityId || res.data[0].id, areaId)
                }
            })
        },
        getAreaList: function (cityId, areaId) {
            const params = {
                type: 3,
                id: cityId
            }

            getAreaList(params).then(res => {
                if (res.code === 1) {
                    let arr = []

                    res.data.forEach(element => {
                      const obj = {
                        text: element.name,
                        value: element.id
                      }

                      arr.push(obj)
                    })

                    const cell = {
                        values: arr,
                        defaultIndex: arr.findIndex(item => item.value == areaId) || 0
                    }

                    this.$set(this.areaColumns, 2, cell)
                }
            })
        },
        getSmsCode: function () {
            const params = {
                mobile: this.phone,
                event: 'check'
            }

            console.log('请求次数', 1)

            getSmsCode(params).then(res => {
                if (res.code === 1) {
                    this.$notify({ type: 'success', message: '验证码发送成功' })
                } else {
                    this.$notify({ type: 'success', message: res.msg })
                }
            })
        },

        getSearchString: function (key, Url) {
            if (Url.indexOf('?') < 0) return

            // url = 'http://172.16.21.66:8080/#/yashiApply?token=a7f1673a-a8c7-4df6-8e60-2ae8c0d3f61b&scene=xianshang'
            let str = Url
            // str = str.substring(1, str.length)
            const arr = str.split("?")[1].split('&')
            let obj = new Object()
            
            for (let i = 0; i < arr.length; i++) {
                let tmp_arr = arr[i].split("=")
                obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(tmp_arr[1])
            }

            return obj[key]
        },

        nameInput: function (value) {
            this.name = value
        },
        phoneInput: function (value) {
            this.phone = value
        },
        codeInput: function (value) {
            this.code = value
        },
        addressInput: function (value) {
            this.inputAddress = value
        },
        submit: function () {
            if (!this.checked) {
                this.$notify({ type: 'warning', message: '请先勾选《法律条款》和《隐私政策》' })

                return
            }

            if (!this.name) {
                this.$notify({ type: 'warning', message: '请输入姓名' })

                return
            }

            if (!this.phone) {
                this.$notify({ type: 'warning', message: '请输入手机号' })

                return
            }

            if (!this.code) {
                this.$notify({ type: 'warning', message: '请输入验证码' })

                return
            }

            if (this.address === '请选择地址') {
                this.$notify({ type: 'warning', message: '请选择地址' })

                return
            }

            const params = {
                name: this.name,
                mobile: this.phone,
                province: this.provinceId,
                city: this.cityId,
                county: this.areaId,
                address_name: this.address,
                scene_name: this.scene,
                type: this.serviceId,
                sms_code: this.code,
                address_name: this.inputAddress
            }

            activeApply(params).then(res => {
                if (res.code === 200) {
                    this.$notify({ type: 'success', message: '提交成功' })
                } else {
                    this.$notify({ type: 'danger', message: res.msg })
                }
            })
        },

        clickAddress: function () {
            this.showAddress = true
        },
        onAreaConfirm: function (value, index) {
            this.address = `${value[0].text} ${value[1].text} ${value[2].text}`
            this.provinceId = `${value[0].value}`
            this.cityId = `${value[1].value}`
            this.areaId = `${value[2].value}`
            this.showAddress = false
        },
        onAreaCancel: function () {
            this.showAddress = false
        },
        onAreaChange: function (picker, value, index) {
            const id = value[index].value
            const text = value[index].text

            switch (index) {
                case 0:
                    // 改变的是省
                    this.getCityList(id)
                    break;
                case 1:
                    // 改变的是市
                    this.getAreaList(id)
                    break;
                case 2:
                    // 改变的是区
                    break;
                default:
                    break;
            }
        },

        getCode: function () {
            const reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
            if (!reg.test(this.phone)) {
                this.$notify({ type: 'warning', message: '请输入正确的手机号' })

                return
            }
            if (timer) clearInterval(timer)
            if (this.isCountDown) return

            this.getSmsCode()

            this.codeMessage = `${this.time}s`
            this.isCountDown = true

            const timer = setInterval(() => {
                let tempTime = this.time
                this.time = --tempTime
                this.codeMessage = `${this.time}s`

                if (this.time === 0) {
                    this.isCountDown = false
                    this.codeMessage = '获取验证码'
                    this.time = 60

                    clearInterval(timer)
                }
            }, 1000)
        },

        check: function () {
            this.checked = !this.checked
        },

        servicePop: function () {
            this.serviceShow = true
        },
        onConfirm: function (obj, index) {
            this.serviceShow = false
            this.service = obj.text
            this.serviceId = obj.value
        },
        onChange: function (picker, value, index) {
            console.log(picker, value, index)
        },
        onCancel: function () {
            this.serviceShow = false
        },

        cluse: function () {
            this.$router.push('/cluse')
        },
        privacy: function () {
            this.$router.push('/privacy')
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/yashiApply.vue